export enum ExampleDataset {
    TRAINING = "TRAINING",
    VALIDATION = "VALIDATION"
}

export function resolveDatasetName(dataset: ExampleDataset) {
    return dataset === ExampleDataset.TRAINING ? "Training" : "Validation"
}